export default __webpack_public_path__ + "static/video-3-4ed938d03b4aa763f54e78694fdb202c.png";